import React from 'react';

import Logo from '../../static/images/logo-test.svg';
import HeroBg from '../../static/images/hero-bg.jpg';
import process from '../../static/images/process.jpg';
import process2 from '../../static/images/process-2.png';
import process3 from '../../static/images/process-3.jpg';

const LandingScreen = () => {
  return (
    <div>
      <div
        style={{
          height: '100dvh',
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          flexDirection: 'column',
        }}
      >
        <img
          src={HeroBg}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: -1,
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            zIndex: 1,
          }}
        />
        <div className="landing-container">
          <img src={Logo} style={{ width: 220, height: 'auto', objectFit: 'contain' }} />
          <nav className="nav-container">
            <ul style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
              <li style={{ listStyle: 'none' }}>
                <a href="#about" style={{ color: '#ECEFF1', textDecoration: 'none', fontSize: '1.2rem' }}>
                  About
                </a>
              </li>
              <li style={{ listStyle: 'none' }}>
                <a href="#work" style={{ color: '#ECEFF1', textDecoration: 'none', fontSize: '1.2rem' }}>
                  Work
                </a>
              </li>
              <li style={{ listStyle: 'none' }}>
                <a href="#team" style={{ color: '#ECEFF1', textDecoration: 'none', fontSize: '1.2rem' }}>
                  Team
                </a>
              </li>
              <li style={{ listStyle: 'none' }}>
                <a href="#contact" style={{ color: '#ECEFF1', textDecoration: 'none', fontSize: '1.2rem' }}>
                  Contact
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="landing-content">
          <h1 style={{ color: '#ECEFF1', fontSize: '3.5rem', fontWeight: 'bold', textAlign: 'center' }}>
            Build. Scale. Conquer.
          </h1>
          <p style={{ color: '#ECEFF1', fontSize: '2rem', fontWeight: 'normal', marginTop: 0, textAlign: 'center' }}>
            Empowering Startups with Nearshore Tech Expertise
          </p>
        </div>
      </div>
      <section className="about-section">
        <h2>About</h2>
        <p>
          Salkantai is a nearshore tech company that provides expert software development services to startups and
          established companies. Our team of experienced developers and project managers are dedicated to delivering
          high-quality solutions that help businesses grow and succeed.
        </p>
      </section>
      <section className="about-section">
        <h2>Services</h2>
        <div style={{ color: '#009688', fontSize: '1.5rem', fontWeight: 'light', textAlign: 'center' }}>
          1. From Idea to Summit
        </div>
        <p>
          Our process is designed to be transparent and collaborative, ensuring that you get the best possible results.
        </p>
        <div>
          <img src={process} />
        </div>
        <ul>
          <li>
            <span>1. Basecamp (Ideation)</span> — This is the starting point at the foot of the mountain. Brainstorming
            ideas, gathering inspiration, and defining the app’s core purpose — just like preparing for a hike.
          </li>
          <li>
            <span>2. Trailhead (Planning)</span> — Strategic planning, outlining app features, setting goals, and
            defining the tech stack — mapping out the journey ahead.
          </li>
          <li>
            <span>3. Mid-Ascent (Development)</span> — Writing code, building features, and integrating APIs — the hard
            work of building the app, step by step.
          </li>
          <li>
            <span>4. Checkpoint (Testing)</span> — QA testing, debugging, and ensuring every feature works — just like
            checking your equipment during a hike.
          </li>
          <li>
            <span>5. Summit (Launch)</span> — Launching it into the world, reaching the goal, and celebrating the
            achievement.
          </li>
          <li>
            <span>6. Beyond the Summit (Conquer)</span> — After launch — scaling the platform, adding new features, and
            growing the user base — because the journey doesn’t stop at the summit.
          </li>
        </ul>
        <div>
          <img src={process2} />
        </div>
        <div style={{ color: '#009688', fontSize: '1.5rem', fontWeight: 'light', textAlign: 'center', marginTop: 50 }}>
          2. Augment your team
        </div>
        <p>We offer a range of services to help you grow your business.</p>
        <div>
          <img src={process3} />
        </div>
        <ul>
          <li>
            <span>1. UI/UX Design</span> — We create beautiful and intuitive designs that help you stand out from the
            competition.
          </li>
          <li>
            <span>2. Mobile Development</span> — We build modern and responsive mobile applications that are easy to use
            and navigate using React Native.
          </li>
          <li>
            <span>3. Frontend Development</span> — We build modern and responsive frontend interfaces that are easy to
            use and navigate.
          </li>
          <li>
            <span>4. Full Stack Development</span> — We build modern and responsive full stack applications that are
            easy to use and navigate.
          </li>
          <li>
            <span>5. Backend Development</span> — We build robust and scalable backend systems that help you manage your
            data and users.
          </li>
          <li>
            <span>6. DevOps</span> — We manage your infrastructure and ensure your application is always running
            smoothly.
          </li>
          <li>
            <span>7. QA</span> — We test your application to ensure it is working as expected and meets your business
            requirements.
          </li>
        </ul>
      </section>
      <footer>
        <img src={Logo} style={{ width: 220, height: 'auto', objectFit: 'contain' }} />
        <p>&copy; 2025 Salkantai. All rights reserved.</p>
      </footer>
    </div>
  );
};

LandingScreen.id = 'com.SalkantayLabs.Landing';

export default LandingScreen;
